import CreditCardForm from './CreditCardForm'
import makeAsyncScriptLoader from 'react-async-script'

export default makeAsyncScriptLoader('https://js.stripe.com/v2/', {globalName: 'stripeJsLibrary'})(CreditCardForm)
